import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE } from './constants';

class ProvozovnaApi extends BaseApi {
	async getProvozovnaTableSchema(tableName: string) {
		return this.fetch(`/${this.area}/${tableName}/Schema`);
	}

	async getProvozovnaTableSchemaAndRows(filter: { ProvozovnaId: number, wantRows: boolean }, tableName: string) {
		return this.fetch(`/${this.area}/${tableName}/GetSchemaAndRows`, filter);
	}

	async updateFleetCentrumRow(params: { id: number, checkbox: boolean }) {
		return this.update(`/${this.area}/FleetCentrum?id=${params.id}&checkbox=${params.checkbox}`);
	}

	async updateCertSpecOpravRow(params: { id: number, checkbox: boolean }) {
		return this.update(`/${this.area}/SpecialistaNehody?id=${params.id}&checkbox=${params.checkbox}`);
	}

	async DealerWorkShopDetails(params: any) {
		return this.fetch('Administrace/Provozovna/DealerWorkShopDetails', params);
	}
}

export const apiProvider = new ProvozovnaApi(DMS_MODULE, NAME);
